import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ArrowRight } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await register(form);
    setBusy(false);
    if (!res.ok) return setError(res.error);
    nav("/portal");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8">
          <img src="/brand/logo-white-512.png" alt="Coastal Bend Contractor Co." className="h-32 w-auto object-contain" />
        </Link>

        <div className="card p-8">
          <h1 className="font-display text-2xl lg:text-3xl font-bold mb-2">Create your account.</h1>
          <p className="text-sm mb-6" style={{color:'var(--text-muted)'}}>For homeowners. Track estimates, projects, and pay invoices online.</p>

          <form onSubmit={submit} className="space-y-4">
            <Field label="Full name" required>
              <input className="input" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="register-name" />
            </Field>
            <Field label="Email" required>
              <input type="email" className="input" required value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} data-testid="register-email" />
            </Field>
            <Field label="Phone">
              <input className="input" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} data-testid="register-phone" />
            </Field>
            <Field label="Password" required>
              <input type="password" minLength={6} className="input" required value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} data-testid="register-password" />
            </Field>
            {error && <div className="text-sm" style={{color:'#fca5a5'}} data-testid="register-error">{error}</div>}
            <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="register-submit">
              {busy ? "Creating account…" : (<>Create account <ArrowRight size={15}/></>)}
            </button>
          </form>

          <div className="divider my-6"/>
          <div className="text-sm text-center" style={{color:'var(--text-muted)'}}>
            Already have an account? <Link to="/login" className="hover:underline" style={{color:'var(--accent)'}} data-testid="register-login-link">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, required, children }) {
  return (
    <label className="block">
      <div className="text-xs uppercase tracking-wider mb-2 font-semibold" style={{color:'var(--text-muted)'}}>
        {label}{required && <span style={{color:'var(--accent)'}}> *</span>}
      </div>
      {children}
    </label>
  );
}
